import { RestUrl } from "../common/cyan.types";

export class UserDeviceUrl {
  public static notifyMyUnauthorizedDevice: RestUrl = ["POST", "/my/devices/notify-unauthorized-device"];
  public static createMyDevice: RestUrl = ["POST", "/my/devices"];
  public static paginateMyDevices: RestUrl = ["GET", "/my/devices"];
  public static deleteMyDevice: (deviceId: bigint) => RestUrl = deviceId => ["DELETE", `/my/devices/${deviceId}`];
}
